//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useRef, useState } from 'react';

import { useTheme } from '@mui/material/styles';
import {
  Box,
  Button,
  Card,
  CardHeader,
  IconButton,
} from '@mui/material';
import {
  InsertComment,
  Cancel, CheckCircle, Gavel, CircleOutlined
} from '@mui/icons-material';

// === API ===
import { onCorrectionMode, overruleFileException, removeListener, requestCorrectionMode, updateFileRuleComment } from 'api/prokey/prokey.websocket';

// === COMPONENTS ===
import { Field } from '../../components/Field/Field';
import { CommentModal } from '../../components/CommentModal/CommentModal';

//#endregion

//-----------------------------------------------------------------
export function Exception( { data } ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const ref = useRef();

  const theme    = useTheme   ();

  const [ mode     , setMode    ] = useState( false );
  const [ is_open  , setIsOpen  ] = useState( false );
  const [ is_open2 , setIsOpen2 ] = useState( false );
  const [ status   , setStatus  ] = useState( data.status  );
  const [ comment  , setComment ] = useState( data.comment );

  const is_correct_all = mode === 'CORRECT-ALL';

  const is_passed = [1,3].includes( status );

  const _status_icons = {
    0 : <Cancel color='error'/>,
    1 : <CheckCircle color='success'/>,
    2 : <Gavel color='success'/>,
    3 : <CircleOutlined color='success'/>,
  }

  //#endregion

  //#region [STYLES]

  const _styles = {
    field_paper: {
      marginTop: '1rem',
      gridColumn: 'span 4',
      overflow : 'auto'     ,
      position : 'relative' ,
      width    : '100%',
      boxShadow: 0,
      overflow: 'hidden',
    },
    document_container: {
      width: '100%',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],

      scrollbarWidth: "none", // Hide the scrollbar for firefox
      '&::-webkit-scrollbar': {
          display: 'none', // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
      },
      '&-ms-overflow-style:': {
          display: 'none', // Hide the scrollbar for IE
      },
    },
    card: {
      variant: 'primary',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    header: {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    footer: {
      display: 'block',
      height: '4rem',
      padding: '0.5rem',
      paddingLeft: '1rem',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    overrule: {
      display: is_passed ? 'none' : '',
    },
    comment: {
      display: '',
    },
  }

  const
    CONTAINER = {
      ref: ref,
      sx : _styles.field_paper,
    },
    CARD = {
      variant: 'primary',
      sx: {
        // width:'100%',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.primary[theme.palette.mode]
      }
    },
    HEADER = {
      sx: _styles.header,
      title: data.id + '. ' + data.description,
      children: data.id + '. ' + data.description
    },
    FOOTER = {
      sx: _styles.footer,
    },
    BUTTON_OVERRULE = {
      sx       : _styles.overrule,
      key      : 'OVERRULE',
      variant  : 'contained',
      color    : 'primary',
      onClick: () => { setIsOpen2(true) },
      children : ['OVERRULE'],
      name     : 'da_overrule_exceptions_btn',
    },
    COMMENT = {
      sx       : _styles.comment,
      onClick: () => { setIsOpen(true) },
      name     :'da_comment_exceptopns_btn'
    };

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleCorrectionMode(data) {
      //-----------------------------------------------------------------
      setMode( data );
    }

    onCorrectionMode( handleCorrectionMode );
    requestCorrectionMode();
    
    return () => {
      removeListener( 'CORRECTION-MODE', handleCorrectionMode );
    };
  }, [] )

    // useEffect( () => {
    //   function handleKeyDown( event ) {
    //     if( event.ctrlKey && event.key === 'm') {
    //       setIsOpen(true);
    //     }
    //     else if( event.ctrlKey && event.key === 'o') {
    //       handleOverrule();
    //     }
    //   }

    //   ref.current?.addEventListener( 'keydown', handleKeyDown );
    
    //   return () => {
    //     ref.current?.removeEventListener( 'keydown', handleKeyDown );
    //   }
    // }, [ref.current] )    

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onModalClose( event ) {
    //-----------------------------------------------------------------
    try {
      setIsOpen (false)
      setIsOpen2(false)
    } catch (error) {
      console.warn(error);
    }
  }

  //-----------------------------------------------------------------
  function onOverrideModalConfirm( text ) {
    //-----------------------------------------------------------------
    try {
      setIsOpen2(false)
      overruleFileException( data.id, text );
      setStatus( 2 );
      setComment( text );
    } catch (error) {
      console.warn(error);
    }
  }

  //-----------------------------------------------------------------
  function onCommentModalConfirm( text ) {
    //-----------------------------------------------------------------
    try {
      setIsOpen(false)
      updateFileRuleComment( data.id, text );
      setComment( text );
    } catch (error) {
      console.warn(error);
    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    let column_count = 1;
    const blocks = data.blocks?.map( (block,row) => {
      // const block = data.blocks.items[block_id];
      const filtered = block.fields.filter( field => is_correct_all || !field.passed )
      column_count = filtered.length;
      
      if( data.is_table ) {
        return filtered.map( (field, column) => <Field key={field.Name} field={field} row={row+1} column={column+1} />  );
      }
      
      return <Box sx={ {
        display: 'flex',
        // width: '90%',
      } }  name='da_exeptions_field_input'> { filtered.map( (field, column) => <Field key={field.Name} field={field} row={row+1} column={column+1} /> ) } </Box>
    });

    return (
      <Box { ...CONTAINER }>
        <Card { ...CARD }>
          <Box sx={{ margin: '0.5rem', float: 'right'}}>
            { _status_icons[status] || <div /> }
          </Box>
          <CardHeader { ...HEADER } />
          <Box sx={{display: (data.is_table ? 'grid' : ''), gridTemplateColumns: (data.is_table ? `repeat( ${column_count}, 1fr )` : ''), gridTemplateRows: (data.is_table ? `repeat( ${blocks.length}, 1fr )` : ''), width:'100%', overflow:'auto'}}>
            {blocks}
          </Box>
          <Box { ...FOOTER }>
            <CommentModal id={data.id} is_open={is_open2} value={comment} onClose={onModalClose} onConfirm={onOverrideModalConfirm} />
            <CommentModal id={data.id} is_open={is_open } value={comment} onClose={onModalClose} onConfirm={onCommentModalConfirm} />
            <Button { ...BUTTON_OVERRULE } />
            <IconButton {...COMMENT}>
              <InsertComment />
            </IconButton>
          </Box>
        </Card>
      </Box>
    );
  }

  //#endregion

  return display();
}